(ns minorodata.components.pipeline-editor.table
  (:require
   ["@xyflow/react" :refer [ReactFlowProvider]]
   ["allotment" :refer [Allotment]]
   [goog.functions :refer [debounce]]
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.components.pipeline-editor.dag :refer [subdag]]
   [minorodata.components.pipeline-editor.details.core :refer [details]]
   [re-posh.core :as re-posh]
   [ui.drawer]))


(defn fetch-table-dag [dag-id filters]
  (dispatch [:pipeline-editor.events/set-dag-filter {:params (merge {:id dag-id}
                                                                    filters)}]))


(defn dag [{:keys [table-id dag-data]}]
  [:div {:class "h-full"}
   [:f> subdag {:id            table-id
                :dag-data      dag-data
                :apply-filters #(fetch-table-dag (:id dag-data) %)}]])

(defn table-page' [{:keys [table-id group-id selected table table-data dag-data panel-state]}]
  [:> Allotment {:vertical true
                 :default-sizes (:sizes panel-state)
                 :on-change     (debounce #(dispatch [:pipeline-editor.events/set-panel-sizes %])
                                          200)}
   [:> Allotment.Pane {:min-size       150
                       :preferred-size "50%"
                       :snap           true}
    [dag {:table-id table-id
          :dag-data dag-data}]]
   [:> Allotment.Pane {:min-size       200
                       :preferred-size "50%"
                       :class          "overflow-hidden"
                       :snap           true}
    [details {:selected selected}]]])

(defn table-page [{:keys [table-id group-id] :as props}]
  (let [panel-state         @(re-posh/subscribe [:pipeline-editor.subs/panel])
        table-data          @(re-posh/subscribe [:pipeline-editor.subs/table table-id])
        sandbox?            @(re-posh/subscribe [:sandbox.subs/enabled?])
        dag-data            @(re-posh/subscribe [:pipeline-editor.subs/dag table-id :table sandbox?])
        query               @(re-posh/subscribe [:app-route/prop :app-route/query])
        table-data-loading? (or @(re-posh/subscribe [:mold-http/loading? :pipeline-editor.api/fetch-live-table])
                                @(re-posh/subscribe [:mold-http/loading? :sandbox.api/fetch-sandbox-table]))]

    [:> ReactFlowProvider
     [:f> table-page' (assoc props
                             :panel-state        panel-state
                             :table-data         table-data
                             :table-data-loading table-data-loading?
                             :dag-data           dag-data
                             :selected           (if (:tab-preview-type query)
                                                   {:type (:tab-preview-type query)
                                                    :id   (:tab-preview-id query)
                                                    :group-id (:tab-preview-group-id query)
                                                    :preview true}
                                                   {:type "table"
                                                    :id table-id
                                                    :group-id group-id}))]]))
